import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import Features from './pages/Features';
import UserGuide from './pages/UserGuide';
import SupportedDevices from './pages/SupportedDevices';
import References from './pages/References';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import Users from './pages/Users';
import ComingSoon from './pages/ComingSoon';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="/features" element={<Features />} />
            <Route path="/guide" element={<UserGuide />} />
            <Route path="/devices" element={<SupportedDevices />} />
            <Route path="/references" element={<References />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/users" element={<Users />} />
            <Route path="/reports" element={<ComingSoon />} />
            <Route path="/devices-monitor" element={<ComingSoon />} />
            <Route path="/comparison" element={<ComingSoon />} />
            <Route path="/notifications" element={<ComingSoon />} />
            <Route path="/admin/dashboard" element={<ComingSoon />} />
            <Route path="/forgot-password" element={<ComingSoon />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
